import * as React from 'react';
import { useAppSelector } from '>root/store/main';

import {assertAuthenticatedAuthState} from '>lib/assert';
import {history} from '../history';
import {StyledBanner} from '>root/pages/page.styles';

export const Impersonation: React.FC = () => {
  const authInfoStore = useAppSelector((state) => state.auth);
  assertAuthenticatedAuthState(authInfoStore);

  const isImpersonated = authInfoStore.isImpersonated;

  const unImpersonate = React.useCallback(() => {
    history.push('/logout');
  }, []);

  return (
    <>
      {isImpersonated && (
        <StyledBanner name={authInfoStore.token.user.name} unImpersonate={unImpersonate} />
      )}
    </>
  );
};
